import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BackArrow from "../../components/backArrow";
import Promotionleftside from "./component/promotionleftside";
import Promotionrightside from "./component/promotionrightside";
import OrderSumary from "../PaymentModal/Components/OrderSumary";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCreatePromotion } from "../../hooks/useCreatePromotion";
import { promotionSchema } from "../../hooks/promotionValidation";
import { FailedNotify } from "../../constants/tostify";
import Loader from "../../components/Loader";

const Promotionmerge = () => {
  const { shopid } = useParams();
  const navigate = useNavigate();

  const [promoteShop, setPromoteShop] = useState({
    type: "",
    description: "",
    media: [],
    location: { country: "", state: "", city: "" },
    ageMin: "",
    ageMax: "",
    gender: "all",
    language: "",
    businessTypes: [],
    placement: "",
    startDate: "",
    endDate: "",
    currency: "USD",
    dailyBudget: "",
    estimateAudience: "",
    status: true,
  });

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    trigger,
  } = useForm({
    resolver: yupResolver(promotionSchema),
    defaultValues: promoteShop,
    mode: "onBlur",
  });

  // Keep RHF description in sync when promoteShop changes from left side
  useEffect(() => {
    setValue("description", promoteShop.description || "", {
      shouldValidate: false,
    });
    setValue("type", promoteShop.type || "", { shouldValidate: false });
    setValue("media", promoteShop.media || [], { shouldValidate: false });
    setValue("location", promoteShop.location || { country: "", state: "", city: "" }, {
      shouldValidate: false,
    });
    setValue("businessTypes", promoteShop.businessTypes || [], {
      shouldValidate: false,
    });
    setValue("placement", promoteShop.placement || "", { shouldValidate: false });
    setValue("startDate", promoteShop.startDate || "", { shouldValidate: false });
    setValue("endDate", promoteShop.endDate || "", { shouldValidate: false });
    setValue("dailyBudget", promoteShop.dailyBudget === "" ? undefined : Number(promoteShop.dailyBudget), {
      shouldValidate: false,
    });
  }, [promoteShop, setValue]);

  const {
    submitPromotion,
    estimateAudience,
    estimatedAudience,
    isSubmitting,
    isEstimating,
  } = useCreatePromotion();

  const [showPayment, setShowPayment] = useState(false);
  const [createdAdId, setCreatedAdId] = useState(null);
  const [adBudget, setAdBudget] = useState(0);

  useEffect(() => {
    setPromoteShop((prev) => ({
      ...prev,
      estimateAudience: estimatedAudience,
    }));
  }, [estimatedAudience]);

  const promotData = handleSubmit(
    async () => {
      const result = await submitPromotion(promoteShop, shopid);
      if (result && result.success) {
        setCreatedAdId(result.adId);
        setAdBudget(result.budget);
        setShowPayment(true);
      }
    },
    (formErrors) => {
      const first =
        formErrors?.description?.message ||
        formErrors?.type?.message ||
        formErrors?.media?.message ||
        formErrors?.location?.country?.message ||
        formErrors?.businessTypes?.message ||
        formErrors?.placement?.message ||
        formErrors?.startDate?.message ||
        formErrors?.endDate?.message ||
        formErrors?.dailyBudget?.message ||
        "Please fix the highlighted fields.";
      FailedNotify(first);
      // Focus description validation message in UI
      trigger("description");
    },
  );

  const handlePaymentComplete = () => {
    setShowPayment(false);
    navigate("/BuyingSide");
  };

  if (isSubmitting) return <Loader heightsetting="screenHeight" />;

  return (
    <Row>
      <Container>
        <div className="screenHeight d-flex justify-content-center">
          <div className="Form-Shadow col-lg-9 pb-4">
            <div className="ps-5 p-2">
              <BackArrow />
            </div>

            <Row className="p-3">
              <Col lg="5">
                <Promotionleftside
                  promoteShop={promoteShop}
                  setPromoteShop={setPromoteShop}
                  control={control}
                  errors={errors}
                />
              </Col>

              <Col lg="7">
                <Promotionrightside
                  promoteShop={promoteShop}
                  setPromoteShop={setPromoteShop}
                  promotData={promotData}
                  estimateAudience={estimateAudience}
                  estimatedAudience={estimatedAudience}
                  isEstimating={isEstimating}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Container>

      {showPayment && (
        <OrderSumary
          isOpenone={showPayment}
          SetisOpenone={setShowPayment}
          adId={createdAdId}
          budget={adBudget}
          onComplete={handlePaymentComplete}
        />
      )}
    </Row>
  );
};

export default Promotionmerge;
